export const LIVE_POLL_INTERVAL_MS = 30000;

export const table = {
  primaryData: [
    { title: "Class", value: "meetingTitle", type: "configue" },
    { title: "Subject", value: "subjectName", type: "configue" },
    { title: "Scheduled", value: "scheduledStartTime", type: "configue" },
    { title: "Mapped", value: "mapped", type: "configue" },
    { title: "Present", value: "present", type: "configue" },
    { title: "Absent", value: "absent", type: "configue" },
    { title: "Attendance %", value: "attendance", type: "configue" },
    { title: "Status", value: "status", type: "configue" },
  ],
  secondaryData: [],
};

const toText = (value: any) => (value === undefined || value === null ? "-" : String(value));

export const buildAttendanceRow = (row: any, report: any) => {
  return {
    id: row?.id,
    meetingTitle: toText(row?.meetingTitle),
    subjectName: toText(row?.subjectName),
    scheduledStartTime: toText(row?.scheduledStartTime),
    mapped: toText(report?.mappedStudentCount),
    present: toText(report?.presentStudentCount),
    absent: toText(report?.absentStudentCount),
    attendance: toText(report?.attendancePercentage),
    status: toText(row?.status),
  };
};
